import { Typography } from '@mui/joy';
import React from 'react';
import useI18n from '@mono-farmart-web/i18n/hooks/usei18n';
import { keys } from '@mono-farmart-web/i18n/Keys';

function ChatHistoryFooter() {
	const { t } = useI18n();
	return (
		<Typography
			level='h2'
			textColor='background.level2'
			sx={{ margin: '7px 0 5px' }}
		>
			{t(keys.your_agri_business_partner)}
		</Typography>
	);
}

export default React.memo(ChatHistoryFooter);
